import React, { createContext, useContext, useState } from 'react'

export const AddToTrolleyContext = createContext()

export const useAddToTrolleyContext = () => {
  const context = useContext(AddToTrolleyContext)
  if (context === undefined) {
    throw new Error('useAddToTrolleyContext must be used within an AddToTrolleyProvider')
  }
  return context
}

const initialProps = {
  show: false,
  modalProps: {
    productId: '',
    quantity: null
  }
}

export const AddToTrolleyProvider = ({ children }) => {
  const [addToTrolleyState, setAddToTrolleyState] = useState(initialProps)

  return (
    <AddToTrolleyContext.Provider value={{ addToTrolleyState, setAddToTrolleyState }}>
      {children}
    </AddToTrolleyContext.Provider>
  )
}
